/** @format */

export const getUnixDateFromTimestamp = timestamp => {
  const date = new Date(timestamp * 1000 * -1);

  const dateObj = {
    hours: date.getHours(),
    minutes:
      date.getMinutes().toString().length === 2
        ? date.getMinutes()
        : '0' + date.getMinutes().toString(),
    seconds: date.getSeconds(),
    day: date.getDate(),
    month: Number(date.getMonth()) + 1,
    year: date.getFullYear(),
  };

  let month =
    dateObj.month.toString().length === 1
      ? '0' + dateObj.month.toString()
      : dateObj.month;
  let day =
    dateObj.day.toString().length === 1
      ? '0' + dateObj.day.toString()
      : dateObj.day;

  return dateObj.year + '-' + month + '-' + day;
};
